import React from 'react';
import { NotificationSource } from '../types/chat';

// Determines if navigation notification should be sent to VQA (empty chat + not already sent)
export const shouldSendNotificationMessageToVQA = (locationState: any, conversationsLength: number, initialMessageSent: boolean) => {
    const state = locationState as { initialMessage?: string };
    return state?.initialMessage && conversationsLength === 0 && !initialMessageSent;
};

// Checks if user clicked notification banner on same VQA page (ref contains event ID)
export const checkInPageNotification = (notificationEventIdRef: React.MutableRefObject<string | null>) => {
    return !!notificationEventIdRef.current;
};

// Checks notification source and returns source with logging
export const checkNotificationSource = (isNavigationBased: boolean, inPageNotificationEventIdRef: React.MutableRefObject<string | null>): NotificationSource => {
    const isInPageClick = !!inPageNotificationEventIdRef.current;
    
    const source = isNavigationBased && isInPageClick ? NotificationSource.BOTH : 
                   isNavigationBased ? NotificationSource.NAVIGATION : 
                   isInPageClick ? NotificationSource.IN_PAGE : NotificationSource.NONE;

    console.log('🔔 Notification source:', source);

    
    return source;
};